import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$6 } from './box.js';
import { d as defineCustomElement$5 } from './form-field.js';
import { d as defineCustomElement$4 } from './icon.js';
import { d as defineCustomElement$3 } from './tooltip.js';
import { d as defineCustomElement$2 } from './tooltip-label.js';
import { i as isValid } from './isValid.js';

const datetimeReadonlyCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:inline-block;flex-shrink:0;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host .container{display:inline-flex;flex-direction:column;gap:.25rem}:host .datetime{align-items:center;align-self:stretch;background-color:var(--jw-theme-info-muted-message-bg-color);border-radius:.25rem;color:var(--jw-theme-info-muted-message-color);display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:400;height:2rem;letter-spacing:-.0004em;line-height:1.25rem;padding:0 .5rem}";
const WuiDatetimeReadonlyStyle0 = datetimeReadonlyCss;

const WuiDateTimeReadOnly = /*@__PURE__*/ proxyCustomElement(class WuiDateTimeReadOnly extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.generateUTCDisplayString = (date) => {
            if (!date || !isValid(date)) {
                return 'yyyy-mm-dd, --:--:--';
            }
            const dateUtc = date.toISOString().substring(0, 10);
            const timeUtc = date.toISOString().substring(11, 19);
            return `${dateUtc}, ${timeUtc}`;
        };
        this.date = undefined;
    }
    render() {
        return (h(Host, { key: 'd81d6e62a59adae7c3c6a8cc14e8a682c4123a67' }, h("span", { key: '133d70c42732d4c05930387c4463dbc950cfb830', class: "container" }, h("wui-form-field", { key: '30c3a74558f3649d9e1553202cfa63d941635ed3', label: "UTC" }, h("span", { key: 'f5bca6138d177e684ee606d668a1b59a3c5272d5', class: "datetime" }, this.generateUTCDisplayString(this.date))))));
    }
    static get style() { return WuiDatetimeReadonlyStyle0; }
}, [1, "wui-datetime-readonly", {
        "date": [16]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-datetime-readonly", "wui-box", "wui-form-field", "wui-icon", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-datetime-readonly":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiDateTimeReadOnly);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiDatetimeReadonly = WuiDateTimeReadOnly;
const defineCustomElement = defineCustomElement$1;

export { WuiDatetimeReadonly, defineCustomElement };

//# sourceMappingURL=wui-datetime-readonly.js.map